// extracted by mini-css-extract-plugin
export default {"wrap":"kJ-z","fullWidth":"lJ-z","hideOnDesktop":"mJ-z","content":"nJ-z","hasOpenedNav":"oJ-z","crumbsList":"pJ-z","dropdownsWrap":"qJ-z"};